/**
 * author: Patrick Vyn Badiang
 *
 * description:
 * Is the board Page manager
 */
import BoardSwiper from "./BoardSwiper";
import { Box, Typography } from "@mui/material";
import { mustard } from "../../../styles.tsx";
import PageHero from "../../../utils/PageHero";
import boardHero from "../../../pictures/Hero/BoardHero.svg";


function BoardPage() {

  return (
    <>
      <PageHero
        image={boardHero}
        viewBoxWidth={1909}
        viewBoxHeight={370}
        cropHeight={370}
        bandColor="#AD5D4E"
        accessibleTitle="Our Board! 2026-2027"
        width={{ xs: "94vw", sm: "620px", md: "760px", lg: "1200px", xl: "1413px" }}
      />

      <Box sx={{ bgcolor: "primary.main", px: { xs: "20px", md: "48px" }, py: { xs: "48px", md: "80px" } }}>
        <Typography variant="h2" sx={{ color: mustard, maxWidth: "1200px", mx: "auto" }}>
          Meet the Board
        </Typography>
        <BoardSwiper />
      </Box>
    </>
  );
}

export default BoardPage;
